// extracted by mini-css-extract-plugin
export default {"root":"ClientsTable_root__dPa8o","infiniteScroll":"ClientsTable_infiniteScroll__aS39n"};